import type { AiChatContext } from './aiChat.types';

/** A route selects context; backend permissions still authorize the data. */
export function insuranceChatContext(pathname: string): AiChatContext | undefined {
  return pathname === '/insurance' || pathname.startsWith('/insurance/') ? 'insurance' : undefined;
}
